var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtfAvatarBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -24,
    y: -24,
    width: 84.8125,
    height: 84.8125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_0_831_2402_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 24,
    cx: 18.4062,
    cy: 18.4062,
    r: 17.4062,
    fill: "#25120C",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5774 21.6219C13.7846 21.6219 13.9833 21.5395 14.1298 21.393L21.2721 14.2507C21.5772 13.9456 21.5772 13.451 21.2721 13.1459C20.967 12.8408 20.4723 12.8408 20.1672 13.1459L13.025 20.2882C12.8785 20.4347 12.7961 20.6334 12.7961 20.8406C12.7961 21.2721 13.1459 21.6219 13.5774 21.6219ZM14.8411 22.8915C14.6536 23.079 14.3992 23.1844 14.134 23.1844H12.2336C11.6814 23.1844 11.2336 22.7366 11.2336 22.1844V20.284C11.2336 20.0188 11.339 19.7645 11.5265 19.5769L20.1672 10.9362C20.4724 10.6311 20.967 10.6311 21.2721 10.9362L23.4818 13.1459C23.7869 13.451 23.7869 13.9456 23.4818 14.2507L14.8411 22.8915ZM11.2336 25.5281C11.2336 25.0966 11.5834 24.7469 12.0149 24.7469H24.5149C24.9464 24.7469 25.2961 25.0966 25.2961 25.5281C25.2961 25.9596 24.9464 26.3094 24.5149 26.3094H12.0149C11.5834 26.3094 11.2336 25.9596 11.2336 25.5281Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_831_2402_clip_path",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.4062,
    cy: 18.4062,
    r: 17.4062
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtfAvatarBtn);
export default __webpack_public_path__ + "static/media/ftf_avatar_btn.26c1fec90ca52e4748f745f58913f512.svg";
export { ForwardRef as ReactComponent };